export default __webpack_public_path__ + "static/media/insta-big.3070edfd.svg";